module.exports = __webpack_public_path__ + "img/Pentagon.cf153b13.svg";